<template>
<div>
  <div>
    <template v-if="isPreloadCreation">
      <PreloaderOnCreation/>
    </template>
    <template v-else>
      <div class="login-journal-wrapper">
        <component :is="'style'" v-if="hideBackground">
          html body.promo-page {
          background-image: none !important;
          }
        </component>
        <preloader/>

        <!-- Yandex.Metrika counter -->
        <script type="application/javascript">
          (function (m, e, t, r, i, k, a) {
            m[i] = m[i] || function () {
              (m[i].a = m[i].a || []).push(arguments)
            };
            m[i].l = 1 * new Date();
            k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a)
          })
          (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

          window.ym(56121682, "init", {
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
            webvisor: true
          });
        </script>
        <noscript>
          <div><img src="https://mc.yandex.ru/watch/56121682" style="position:absolute; left:-9999px;" alt=""/></div>
        </noscript>
        <!-- /Yandex.Metrika counter -->

        <div class="main-container-wrapper _promo-container">
          <router-link to="/" class="logo"/>

          <div class="main-container">
            <template v-if="step !== 2.6">
              <div class="enter-title">Ваш личный гид в мире финансов</div>
              <div class="enter-caption">Вход в кабинет /
                <br>регистрация
              </div>
            </template>

            <template v-if="step === 2.6">
              <component :is="'style'">
                html body.promo-page { padding-top: 0; }
              </component>
            </template>

            <template v-if="false">
              <template v-if="step === 2.7">
                <div class="yandex-pay-success">
                  <span>Услуга успешно подключена!</span>
                  <span>Спасибо!</span>
                </div>
              </template>
              <template v-if="step !== 2.6">
                <div class="desc">
                  <template v-if="step !== 2.7">
                    Финансовые статьи<br> и лайфхаки у вас в кармане
                  </template>
                </div>
                <ul class="advantages" v-if="step !== 2.7">
                  <li>коротко</li>
                  <li>уникально</li>
                  <li>актуально</li>
                </ul>
              </template>
            </template>

            <div class="input-containers" :class="{
                  'input-containers-error': response.type === 'error',
                  'input-containers-gray': response.type === 'gray',
                  'input-containers-complete': response.type === 'complete'
                }" :style="step === 2.6 ? { maxWidth: '460px' } : {}">
              <form class="login-form" autocomplete="off">
                <template v-if="step === 1">
                  <label for="phone">Ваш телефон</label>
                  <div class="input-container">
                    <input
                        id="phone"
                        v-mask="'+7 ### ### ## ##'"
                        v-model="phone"
                        type="tel"
                        placeholder="+7 999 123 45 67"
                        class="text-input"
                    >

                  </div>
                  <div class="input-container">
                    <ButtonAction
                        class="main-action-btn"
                        type="submit"
                        :message="response.message || 'Перейти к чтению'"
                        @buttonAction="handleSubmit"
                    />
                  </div>
                </template>

                <template v-if="step === 2 || step === 2.5">
                  <div class="input-container">
                    <label for="code">Код из SMS</label>
                    <input
                        id="code"
                        type="text"
                        :class="{ preload: preload }"
                        placeholder="Введите код из SMS"
                        class="text-input"
                        v-mask="'####'"
                        v-model="code"
                    >
                  </div>
                  <div class="input-container">
                    <ButtonAction
                        class="main-action-btn"
                        :class="{ 'main-action-btn-disabled': codeSubmitDisabled }"
                        type="submit"
                        :message="codeSubmitButton"
                        :isDisabled="codeSubmitDisabled"
                        v-show="code.length !== 4"
                        @buttonAction="sendCode"
                    />
                    <ButtonAction
                        class="main-action-btn"
                        type="submit"
                        :message="response.message || (step === 2 ? 'Продолжить' : 'Зарегистрироваться')"
                        v-show="code.length === 4"
                        @buttonAction="handleSubmit"
                    />
                  </div>
                  <div class="_bottom">
                    <span style="cursor: pointer;" @click="$router.push('/')">Вернуться назад</span>
                  </div>
                </template>

                <template v-if="step === 2.6">
                  <div id="payment-form"></div>
                  <div class="input-container" v-if="false">
                    <a
                        href="#"
                        @click.prevent="yandexPayCancel"
                        class="yandex-pay-cancel"
                        style="margin-left: auto; margin-right: auto;"
                    >
                      Отмена
                    </a>
                  </div>
                </template>

                <template v-if="step === 2.7">
                  <div class="input-container">
                    <a href="#" @click.prevent="startRead" class="yandex-pay-start-read">
                      Начать читать!
                    </a>
                  </div>
                </template>

                <template v-if="step === 3">
                  <div class="input-container">
                    <label class="label-step-3" for="password">
                      <span v-if="response.type === 'error'">Пароль менее 6 символов</span>
                      <span v-else>Задайте пароль для входа не менее 6 символов</span>
                    </label>
                    <div class="input-group">
                      <InputHideShow @setPass="setPass" :hasError="response.type === 'error'"/>
                    </div>
                    <ButtonAction
                        class="main-action-btn"
                        type="submit"
                        :message="response.message || 'Войти'"
                        @buttonAction="handleSubmit"
                    />
                  </div>
                  <div class="_bottom">
                    <span style="cursor: pointer;" @click.prevent="step = 1">Вернуться назад</span>
                  </div>
                </template>
              </form>
            </div>
            <div id="change-phone">Изменить телефон</div>
          </div>
          <FooterAgreement @setAgree="isAgree"/>
        </div>
      </div>
    </template>
  </div>
</div>
</template>

<script>
import request from '@/api/axios';
import eventsBus from "@/api/events";
import Preloader from '@/components/base/Preloader';
import PreloaderOnCreation from '@/components/newRedesign/UI/PreloaderOnCreation';
import FooterAgreement from '@/components/newRedesign/UI/FooterAgreement.vue';
import InputHideShow from "@/components/newRedesign/UI/InputHideShow";
import ButtonAction from "@/components/newRedesign/UI/ButtonAction";

export default {
  data: () => {
    return {
      phone: '',
      password: '',
      subscription_id: '',
      code: '',
      step: 1,
      response: false,
      time: 30,
      seconds: 30,
      codeSubmitDisabled: true,
      preload: false,
      isPreloadCreation: false,
      returnToProfile: false,
      hideBackground: false,
      agreement: true,
      showPassword: false,
      isLogin: false,
      user: null
    }
  },
  components: {
    Preloader,
    PreloaderOnCreation,
    FooterAgreement,
    InputHideShow,
    ButtonAction
  },
  computed: {
    codeSubmitButton: function () {
      if (this.time === 0) return 'Отправить еще раз';
      return 'Отправить еще раз 0:' + (this.time > 9 ? this.time : '0' + this.time);
    }
  },
  watch: {
    phone: function () {
      this.response = false;
    },
    password: function () {
      this.response = false;
    },
    code: function () {
      this.response = false;
    },
    step: function (newStep, oldStep) {
      this.hideBackground = false;
      if (newStep === 2 && oldStep !== 2) {
        this.startTimer();
      }
    }
  },
  async created() {
    if (this.$route.params.yaPay === true) {
      this.preload = false;
      this.step = 2.5;
    } else if (this.$route.params.yaPayWidget === true) {
      this.preload = false;
      await this.showYandexWidget();
    } else if (this.$route.params.activateTele2 === true) {
      if (this.$route.params.phone) {
        this.isPreloadCreation = true;
        this.phone = this.$route.params.phone;
        let phone = this.phone.replace(/\s|\(|\)|-/g, '');
        const checkPhone = await request({action: 'check_phone', options: {phone, reactivate: true, isInvest: location.pathname.includes('invest')}});
        this.subscription_id = checkPhone.data.subscription_id;
        this.isLogin = checkPhone.data.login;
        this.user = checkPhone.data.user;
        this.preload = false;
        this.isPreloadCreation = false;
        this.returnToProfile = true;
        this.step = 2;
      }
    } else {
      let res = await request({action: 'get_tele2_number'});
      if (res && res.data && res.data.phone) {
        this.phone = res.data.phone;
      }
    }
    eventsBus.$emit("page-ready");
  },
  mounted() {
    this.checkHash();
    window.addEventListener('hashchange', this.checkHash, false);
  },
  methods: {
    checkHash() {
      let hash = window.location.hash;
      if (hash && hash === '#success') {
        request({action: 'cancel'});
        this.step = 2.7;
      }
    },
    startRead() {
      this.$router.push('/');
    },
    async yandexPayCancel() {
      this.$router.push('/profile');
    },
    async handleSubmit() {
      const backUrl = this.$route.params.backUrl || this.$route.query.backUrl || null;

      if (!this.agreement) {
        this.response = {
          message: 'Примите соглашение',
          type: 'error'
        };
        return false;
      }

      if (this.preload) return false;
      this.preload = true;
      let phone = this.phone.replace(/\s|\(|\)|-/g, '');

      if (this.step === 1) {
        window.ym(56121682, 'reachGoal', '1button');

        if (phone.length !== 12) {
          if (phone.length === 0) {
            this.response = {message: 'Введите номер телефона', type: 'error'};
            this.preload = false;
            return false;
          }
          this.response = {message: 'Номер указан неверно', type: 'error'};
          this.preload = false;
          return false;
        }

        const checkPhone = await request({action: 'check_phone', options: {phone}});

        this.subscription_id = checkPhone.data.subscription_id;
        this.isLogin = checkPhone.data.login;
        this.user = checkPhone.data.user;

        if (checkPhone.data.status === false) {
          await request({action: 'send_code_other', options: {phone, subscription_id: this.subscription_id}});
          this.step = 2;
          this.preload = false;
          return false;
        } else {
          if (checkPhone.data.exists === true) { // ussd account
            const hostname = window.location.hostname !== 'localhost' ? this.$config.hostname : 'http://localhost:8080';
            location.href = hostname + '/login#phone=' + this.phone;
            this.preload = false;
            return false;
          }
          this.step = 2;
          this.preload = false;
          return false;
        }
      }

      if (this.step === 2) {
        window.ym(56121682, 'reachGoal', '2button');

        if (this.response?.type === 'complete') return false;

        const isCodeValid = (await request({
          action: 'check_code',
          options: {
            phone,
            code: this.code,
            subscription_id: this.subscription_id,
            isInvest: location.pathname.includes('invest')
          }
        })).data;

        if (isCodeValid.status === false) {
          this.response = {message: 'Неверный код', type: 'error'};
          this.preload = false;
          return false;
        }

        if (this.isLogin) {
          this.$store.commit('login', this.user);
          await this.$store.dispatch('getUser');
          if (backUrl != null) {
            this.$router.push(backUrl);
          } else {
            this.$router.push('/profile');
          }
          return false;
        } else {
          this.step = 3;
          this.preload = false;
          return false;
        }
      }

      if (this.step === 2.5) {
        const isCodeValid = (await request({action: 'check_code_other', options: {phone: this.phone, code: this.code}})).data;

        if (isCodeValid.status === false) {
          this.response = {message: 'Код неверный', type: 'error'};
          this.preload = false;
          return false;
        }
        await this.showYandexWidget();
      }

      if (this.step === 3) {
        const setPass = (await request({
          action: 'change_password',
          options: {
            phone,
            password: this.password
          }
        })).data;

        this.preload = false;

        if (setPass.status === false) {
          if (this.password.length < 6) {
            this.response = {message: 'Продолжить', type: 'error'};
            this.preload = false;
            return false;
          }
        } else {
          if (setPass.user.payment.type === 1) {
            this.$store.commit('login', setPass.user);

            this.response = {
              message: 'Услуга подключена',
              type: 'complete'
            };

            if (backUrl != null) {
              this.$router.push(backUrl);
            } else {
              this.$router.push('/profile');
            }
          }
        }
        this.preload = false;
      }
    },
    async showYandexWidget() {
      this.step = 2.6;
      this.hideBackground = true;
      const yandexToken = (await request({action: 'yandex_confirmation_token'})).data;
      this.$nextTick(() => {
        if (yandexToken.token) {
          const checkout = new window.YooMoneyCheckoutWidget({
            confirmation_token: yandexToken.token,
            return_url: 'https://finsite.me/profile#success',
            embedded_3ds: false,
            error_callback(error) {
            }
          });
          checkout.render('payment-form');
        }
      });
    },
    async sendCode() {
      this.startTimer();
      let phone = this.phone.replace(/\s|\(|\)|-/g, '');
      return await request({action: 'check_phone', options: {phone}});
    },
    startTimer() {
      this.time = this.seconds;
      this.codeSubmitDisabled = true;
      let interval = setInterval(() => {
        this.time--;
        if (this.time <= 0) {
          clearInterval(interval);
          this.codeSubmitDisabled = false;
        }
      }, 1000);
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    isAgree(agree) {
      this.agreement = agree
    },
    setPass(pass) {
      this.password = pass
    },
  }
}
</script>

<style scoped lang="scss">
@font-face {
  font-family: 'YesevaOne';
  src: url('../../assets/fonts/YesevaOne-Regular.eot');
  src: local('☺'),
  url('../../assets/fonts/YesevaOne-Regular.woff') format('woff'),
  url('../../assets/fonts/YesevaOne-Regular.ttf') format('truetype'),
  url('../../assets/fonts/YesevaOne-Regular.svg') format('svg');
  font-weight: normal;
  font-style: normal;
}

body,
html,
ul,
li {
  padding: 0;
  margin: 0;
  position: relative;
}

* {
  box-sizing: border-box;
}

li {
  list-style: none;
}

body {
  background-color: #111;
  color: #fff;
  font-family: 'Roboto', sans-serif;
}

.main-container-wrapper {
  max-width: 860px;
  margin: 0 auto;
  position: relative;
  padding: 0 16px;
  color: #fff;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding-top: 126px;
}

@media screen and (max-width: 1300px) {
  .main-container-wrapper {
    padding-top: 47px;
  }
}

.main-container {
  flex: 1 0 auto;
}

header {
  margin-top: 24px;
  margin-bottom: 20px;
}

header h1 {
  font-family: 'YesevaOne' !important;
  font-size: 36px;
  line-height: 37px;
  text-align: center;
  font-weight: 700;
  margin: 0;
  color: #fff;
}

ul.advantages {
  font-weight: 300;
  font-size: 13px;
  line-height: 20px;
  display: flex;
  margin-top: 8px;
  justify-content: center;
}

ul.advantages li {
  margin-left: 10px;
  position: relative;
  padding-left: 10px;
}

ul.advantages li:before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 4px;
  background-color: #fff;
  border-radius: 100%;
  position: absolute;
  left: -2px;
  top: 50%;
  margin-top: -1px;
}

ul.advantages li:first-child {
  margin-left: 0;
}

ul.advantages li:first-child:before {
  display: none;
}


form.login-form .text-input:focus::-webkit-input-placeholder {
  color: transparent;
}

form.login-form .text-input:focus::-moz-placeholder {
  color: transparent;
}

form.login-form .text-input:focus:-moz-placeholder {
  color: transparent;
}

form.login-form {
  margin-top: 0;
}

form.login-form .input-container {
  position: relative;
  max-width: 400px;
}

form.login-form .input-container .input-group-hide-pass {
  position: relative;
}

form.login-form .input-container .checked-icon {
  color: #22b491;
}

form.login-form .input-container .error-icon {
  color: #db1616;
}

svg {
  display: inline-block;
}

form.login-form .text-input {
  width: 100%;
  margin-bottom: 24px;
  padding: 14px;
  text-align: center;
  border-radius: 8px;
  border: 1px solid #22b491;
  outline: none;
  background-color: transparent;
  font-family: Gilroy;
  font-style: normal;
  font-size: 16px;
  line-height: 19px;
}

form.login-form .text-input:focus {
  border-color: #22b491;
}

.input-containers-error form.login-form .text-input {
  border-color: #cf2f38;
}

form.login-form .input-container.complete:not(.error) .text-input {
  border-color: #555;
}

.input-containers-error form.login-form .error-icon {
  display: block;
}

form.login-form .text-input::-webkit-input-placeholder {
  color: #bdbdbd;
}

form.login-form .text-input:-moz-placeholder {
  color: #bdbdbd;
  opacity: 1;
}

form.login-form .text-input::-moz-placeholder {
  color: #bdbdbd;
  opacity: 1;
}

form.login-form .text-input:-ms-input-placeholder {
  color: #bdbdbd;
}

form.login-form .text-input::-ms-input-placeholder {
  color: #bdbdbd;
}

form.login-form .text-input::placeholder {
  color: #bdbdbd;
}

form.login-form input[type="submit"],
.yandex-pay-cancel,
.yandex-pay-start-read {
  cursor: pointer;
  display: block;
  width: 100%;
  max-width: 250px;
  margin-bottom: 24px;
  outline: none;
  background: #22b491;
  border-radius: 8px;
  border: none;
  color: #fff;
  padding: 14px;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
}

.yandex-pay-cancel {
  background-color: #db1616;
  cursor: pointer;
}

form.login-form input[type="submit"].preload {
  background-image: url('../../assets/img/loading.svg');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  color: transparent;
}

.input-containers-error form.login-form input[type="submit"] {
  background-color: #bdbdbd;
}

.input-containers-gray form.login-form input[type="submit"] {
  background: #808080;
}

form.login-form input[type="submit"][disabled] {
  background: #bdbdbd;
  cursor: default;
}

.free,
#change-phone {
  margin-top: 24px;
  margin-bottom: 20px;
  display: none;
  font-family: Circe;
  font-style: normal;
  font-weight: normal;
  font-size: 8px;
  line-height: 11px;
  color: #828282;
}

#change-phone {
  color: #149fed;
  cursor: pointer;
}

.free.active {
  display: block;
}

#change-phone.active {
  display: block;
}

.label-step-3 {
  font-size: 11px;
}

.input-group {
  margin-bottom: 18px;
}

body footer {
  flex: 0 0 auto;
  margin-bottom: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Circe';
  font-weight: normal;
  font-size: 10px;
  line-height: 140%;
  color: #828282;
}

@media screen and (max-width: 650px) and (min-width: 385px) {
  body footer {
    width: 288px;
    margin: 0 auto 24px;
  }
}

.image {
  background-image: url('../../assets/images/page.png');
  background-position: center;
  background-repeat: no-repeat;
  width: 214px;
  height: 379px;
  margin: 0 auto;
  margin-top: 30px;
}

input {
  -webkit-appearance: none;
}

#payment-form {
  background: #fff;
  padding: 15px;
  margin-bottom: 30px;
}

.yandex-pay-success {
  color: #fff;
  text-align: center;
  font-style: normal;
  font-size: 20px;
  line-height: 25px;
  font-weight: 900;
  padding: 30px 30px 20px;
}

.yandex-pay-success span {
  display: block;
  margin-bottom: 30px;
}

form.login-form .yandex-pay-start-read {
  margin-top: 55px;
  background: #18ce56;
  border-radius: 3px;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
}

._p-title {
  font-size: 48px;
  line-height: 52px;
  color: #000;
  font-family: Gilroy;
  font-style: normal;
  font-weight: bold;
}

._p-title span {
  font-family: EB Garamond;
  font-style: italic;
  font-weight: bold;
  font-size: 48px;
  color: #0500e6;
}

._p-advantages {
  font-family: EB Garamond;
  font-style: italic;
  font-weight: bold;
  font-size: 24px;
  line-height: 31px;
  display: flex;
  color: #0500e6;
  margin-top: 20px;
}

._p-advantages li {
  margin-right: 22px;
  position: relative;
}

._p-advantages li:before {
  content: '';
  display: block;
  top: 50%;
  background: #e60045;
  border-radius: 12px;
  width: 6px;
  height: 6px;
  margin-top: 0;
  margin-left: -13px;
  position: absolute;
}

._p-advantages li:first-child:before {
  display: none;
}

label {
  display: block !important;
  font-family: Circe;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 140%;
  color: #828282;
}

@media screen and (max-width: 650px) {

  form.login-form .input-container {
    max-width: 100%;
  }

  form.login-form {
    margin-top: 80px;
  }

  .main-container-wrapper {
    min-height: 100vh;
    width: 288px;
    padding-top: 90px;
    padding-left: 0;
    padding-right: 0;
  }

  .main-container {
    width: 100%;
  }

  ._p-title {
    font-size: 26px;
    line-height: 31px;
  }

  ._p-title span {
    font-size: 30px;
    line-height: 40px;
  }

  ._p-advantages {
    display: block;
    font-size: 14px;
    line-height: 16px;
    color: #333;

    margin-top: 25px;
  }

  ._p-advantages li {
    margin-right: 0;
    padding-left: 11px;
    margin-bottom: 8px;

    font-size: 16px;
  }

  ._p-advantages li:first-child:before {
    display: block;
  }

  ._p-advantages li:before {
    margin-top: -1px;
  }

  form.login-form input[type="submit"] {
    max-width: 100%;
  }
}

form.login-form {
  margin-top: 20px;
}
</style>

<style scoped>

#payment-form iframe {
  min-height: 498px !important;
}

html body.promo-page {
  background-image: url('../../assets/img/bg_login.webp');
  background-color: #f5f5f5;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  min-height: 100vh;
  box-sizing: border-box;
  padding-top: 0;
}

@media screen and (max-width: 1300px) {
  html body.promo-page {
    background-position: -250px -280px;
    background-size: 140%;
  }
}

@media screen and (max-width: 650px) {
  html body.promo-page {
    background-image: url('../../assets/img/__bg-promo.jpg?v3');
    background-size: 100%;
    background-position: left top;
  }
}

.__hide-desktop {
  display: none !important;
}

label.__hide-desktop {
  display: none !important;
}

@media screen and (max-width: 650px) {

  .__hide-desktop {
    display: block !important;
  }

  label.__hide-desktop {
    display: block !important;
  }

  .__hide-mobile {
    display: none !important;
  }

  label.__hide-mobile {
    display: none !important;
  }
}


body footer > div a {
  font-weight: normal !important;
}

.enter-title {
  max-width: 395px;
  margin-bottom: 44px;
  color: #333;
  font-family: 'Gilroy';
  font-weight: 600;
  font-size: 48px;
  line-height: 56px;
}

.enter-caption {
  max-width: 420px;
  margin-bottom: 18px;
  color: #000;
  font-family: 'Gilroy';
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;

}

._promo-container .logo {
  position: absolute;
  top: 20px;
  background-image: url('../../assets/img/login-logo.svg');
  width: 116px;
  height: 36px;
  display: block;
}

._bottom {
  text-align: center;
}

._bottom span {
  font-family: Gilroy;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #828282;
  text-decoration: underline;
}

._bottom span:hover {
  text-decoration: none;
}

.input-containers {
  max-width: 250px;
}

.input-containers label {
  margin-bottom: 0;
}


@media screen and (max-width: 650px) {
  .main-container-wrapper {
    padding-top: 90px;
  }

  .main-container {
    margin-bottom: 30px;
  }

  .enter-caption {
    font-size: 17px;
    font-weight: 600;
    line-height: 20px;
    max-width: 134px;
    text-align: end;
    margin-bottom: 24px;
  }

  .enter-title {
    max-width: 145px;
    margin-bottom: 65px;
    font-size: 28px;
    line-height: 34px;
  }

  .input-containers {
    max-width: 100%;
  }

  form.login-form .text-input {
    font-size: 16px;
    line-height: 16px;
    margin-bottom: 18px;
  }

  input[type="submit"] {
    max-width: 100%;
    margin-bottom: 22px;
  }
}
</style>
